import React from 'react';

import { Badge } from '@rtkwlf/fenrir-react';

import { LogoIcon } from 'ae-components/widgets/Logo';

export interface LogoBadgeProps {
  text: string;
  showLogo?: boolean;
}

export const LogoBadge: React.FC<LogoBadgeProps> = ({ text, showLogo }) => (
  <Badge.Root
    appearance="default"
    style={{ verticalAlign: 'bottom' }}
    margin="xsmall"
  >
    {showLogo && (
      <Badge.Icon data-testid="logo-badge-icon">
        <LogoIcon variant="light" />
      </Badge.Icon>
    )}
    <Badge.Text>{text}</Badge.Text>
  </Badge.Root>
);
